import { alpha } from "@mui/material";
import { CrewComparisonStrikeStatus } from "src/store/api/generatedApi";
import theme from "src/theme";

/**
 * Shared colour sets for charts and status indicators.
 *
 * Strike and crew colours come from `theme.palette.data`; they live here as
 * module-level constants because Plotly trace builders consume them outside
 * React render. Medal colours are bespoke (gold/silver/bronze) and have no
 * palette token.
 */

export const MEDAL_COLORS: Record<number, string> = {
  1: "#FFB404",
  2: "#BFBFBF",
  3: "#CD7E39",
};

export const DEFAULT_MEDAL_COLOR = "#A0A0A0";

export const STRIKE_COLORS: Record<
  CrewComparisonStrikeStatus["status"],
  string
> = {
  red: theme.palette.data.red,
  amber: theme.palette.data.orange,
  green: theme.palette.data.green,
};

export const CREW_COLORS_SOLID: Record<string, string> = {
  A: theme.palette.data.green,
  B: theme.palette.data.blue,
  C: theme.palette.data.pink,
  D: theme.palette.data.orange,
};

export const CREW_COLORS_TRANSLUCENT: Record<string, string> = {
  A: alpha(theme.palette.data.green, 0.19),
  B: alpha(theme.palette.data.blue, 0.19),
  C: alpha(theme.palette.data.pink, 0.19),
  D: alpha(theme.palette.data.orange, 0.19),
};
